import React, { useMemo } from 'react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/atoms/texts/label';

const STEP_COLOR_BY_STEP = {
    PERSONAL_INFO: { bg: '#EAF3DE', text: '#27500A' },
    DOCUMENTS: { bg: '#FCEBEB', text: '#791F1F' },
    CURRENT_MISSION: { bg: '#FCEBEB', text: '#791F1F' },
    SYNAPSE_VALIDATION: { bg: '#FAEEDA', text: '#633806' },
    ADMINISTRATIVE_INFO: { bg: '#EEEDFE', text: '#3C3489' },
    CONTRACT_GENERATION: { bg: '#E6F1FB', text: '#0C447C' },
    OFFICE_APPOINTMENT: { bg: '#F1EFE8', text: '#444441' },
    COMPLETE: { bg: '#F1EFE8', text: '#444441' },
};

const NAME_COLOR_FALLBACKS = [
    { bg: '#EEEDFE', text: '#3C3489' },
    { bg: '#E6F1FB', text: '#0C447C' },
    { bg: '#EAF3DE', text: '#27500A' },
    { bg: '#FAEEDA', text: '#633806' },
    { bg: '#FCEBEB', text: '#791F1F' },
    { bg: '#F1EFE8', text: '#444441' },
];

const getInitials = (firstName, lastName) => {
    const firstInitial = String(firstName || '').trim().charAt(0).toUpperCase();
    const lastInitial = String(lastName || '').trim().charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}` || '-';
};

const getFallbackColor = (firstName = '', lastName = '') => {
    const seed = `${firstName}${lastName}`.trim().toLowerCase();
    const score = Array.from(seed).reduce((accumulator, character) => accumulator + character.charCodeAt(0), 0);
    return NAME_COLOR_FALLBACKS[score % NAME_COLOR_FALLBACKS.length];
};

const AvatarOnboarding = ({ firstName, lastName, step, className }) => {
    const initials = useMemo(() => getInitials(firstName, lastName), [firstName, lastName]);
    const colors = STEP_COLOR_BY_STEP[step] || getFallbackColor(firstName, lastName);

    return (
        <div
            className={cn('flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-semibold', className)}
            style={{ backgroundColor: colors.bg, color: colors.text }}
            aria-hidden="true"
        >
            <Label  fontWeight="bold" className="leading-none" style={{ color: colors.text }}>
                {initials}
            </Label>
        </div>
    );
};

export default AvatarOnboarding;
